// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__JbSC1","header":"ReportDetails_header__PNEPU","title":"ReportDetails_title__17u5W","left":"ReportDetails_left__7a9ze"};